globalThis.leanweb ??= {};
import './components/root/root.js';
import './components/login/login.js';
import './components/pager/pager.js';
import './components/table-card/table-card.js';
import './components/ticket-view/ticket-view.js';
import './components/dashboard/dashboard.js';
